import { FC } from 'react';

import { BodyText, Headline, ProgressTracker, Stack } from '@servicetitan/design-system';

import { Step, Steps } from '../step';

interface RequestAccessHeaderProps {
    currentStep: Step;
}

export const RequestAccessHeader: FC<RequestAccessHeaderProps> = ({ currentStep }) => (
    <Stack direction="column" spacing={3}>
        <Stack direction="column" spacing={1}>
            <Headline el="h1" size="large">
                Request Integration Environment Access
            </Headline>
            <BodyText subdued>Get started with ServiceTitan API development</BodyText>
        </Stack>
        <ProgressTracker currentIndex={currentStep.index}>
            <ProgressTracker.Step label={Steps.YourRole.label} />
            <ProgressTracker.Step label={Steps.GetAccess.label} />
        </ProgressTracker>
    </Stack>
);
RequestAccessHeader.displayName = 'RequestAccessHeader';
